<template>
  <div class="page-container">
    <div class="nav">
      <img src="@/assets/images/logo.png" alt="" class="logo">
    </div>
    <img src="@/assets/images/banner.jpg" alt="" class="banner">
    <div class="form-box">
      <div class="form-item">
        <div class="label">*姓名：</div>
        <input type="text" v-model="customerName" placeholder="请输入姓名"/>
      </div>
      <div class="form-item">
        <div class="label">*电话：</div>
        <input type="text" v-model="customerMobile" placeholder="请输入手机号码"/>
      </div>
      <div class="form-item">
        <div class="label">公司名称：</div>
        <input type="text" v-model="companyName" placeholder="请输入公司名称"/>
      </div>
      <div class="form-item">
        <div class="label">意向区域：</div>
        <input type="text" v-model="intendedArea" placeholder="请输入意向区域，如：北京"/>
      </div>
      
      <div class="ly-line">
        <div class="label">留言：</div>
        <textarea placeholder="欢迎您留言并提供相关信息，我们将第一时间与您取得联系！" v-model="message"></textarea>
      </div>
        
      
    </div>
    <div class="btn-submit" @click="confirm">提交您的信息</div>
  </div>
</template>

<script>
import { Toast } from 'vant'

import $http from '@/lib/request'
import config from '@/config'

import { checkPhoneValue } from '@/lib/util'

export default {
    data(){
        return {
            customerName:null,
            customerMobile:null,
            companyName:null,
            intendedArea:null,
            message:null,
        }
    },
    methods:{
        confirm(){
            if(!this.customerName){
                Toast('请填写姓名！');
                return;
            }
            if(!this.customerMobile){
                Toast('请填写手机号码！');
                return;
            }
            if(!checkPhoneValue(this.customerMobile)){
                Toast('请输入正确手机号');
                return;
            }
            $http({
                method:'post',
                data:{
                    customerName:this.customerName,
                    customerMobile:this.customerMobile,
                    companyName:this.companyName,
                    intendedArea:this.intendedArea,
                    message:this.message
                },
                url:config.api.customerInfo
            }).then(res=>{
                if(res.errno == 0){
                    Toast('提交成功,我们将第一时间与您联系~');
                }else{
                    Toast(res.errmsg);
                }
                
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'huawensong';
  src: url("../../assets/fonts/huawensong.ttf");
}
.page-container{
  padding-top: 49px;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #062745;
  background-image: url('../../assets/images/page-bg.png');
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: 375px 183.5px;
  padding-bottom: 28px;
  .nav{
    width:100%;
    height:49px;
    background-color: #062745;
    position: fixed;
    top:0;
    left:0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .logo{
      width:105.5px;
      padding-left: 26px;
    }
  }
  .banner{
    display: block;
    width:100%;
  }
  .form-box{
    font-family: 'huawensong';
     padding:21px 26px; 
    .form-item{
      border:1px solid #fdc99a;
      padding:0 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      .label{
        width:83px;
        height:32px;
        line-height: 32px;
        font-size: 15px;
        color:#fdc99a;
        text-align: justify;
        text-align-last: justify;
        flex-shrink: 0;
      }
      input{
        background: transparent;
        outline: none;
        font-size: 15px;
        border:none;
        color:#fdc99a;
        width:100%;
        &::placeholder{
            color:rgba(253,201,154,.6)
        }
      }
    }
    .ly-line{
      border:1px solid #fdc99a;
      padding:0 12px;
      padding-bottom: 10px;
      .label{
        width:83px;
        height:32px;
        line-height: 32px;
        font-size: 15px;
        color:#fdc99a;
        text-align: justify;
        text-align-last: justify;
        
      }
      textarea{
        display: block;
        width:100%;
        height:100px;
        box-sizing: border-box;
        border:none;
        outline: none;
        background: transparent;
        padding-top: 10px;
        font-size: 15px;
        color:#fdc99a;
        line-height: 20px;
        resize: none;
        border-radius: 0;
        &::placeholder{
            color:rgba(253,201,154,.6)
        }
      }
    }
  }
  .btn-submit{
    width:162.5px;
    height:31px;
    line-height: 31px;
    text-align: center;
    background: #fdc99a;
    color:#062745;
    font-size: 16px;
    margin:0 auto;
    font-family: 'huawensong';
    font-weight: bold;
  }
}
</style>